// import { EVENTS } from '../../../../../../library';

// export const LOG_EVENT_PATH = (event) => {
//   return EVENTS.COMPONENTS.APPLICATION.REWARDS.REDEEM.DOWNLOAD_MODAL[event];
// };

export const TRANSLATION_PATH = (route) => {
  return `components.application.rewards.filter.${route}`;
};
